'use client';

import { PortableText } from '@portabletext/react';
import { cn } from '@/lib/utils';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { CTAButton } from '@/shadcn/ui/button';
import { PageTextOnlyCryptoSchema } from '@/sanity/pages/PageTextOnlyCryptoTemplate';
import CheckList from './CheckList';
import { CARD_BUTTON_CLASS } from './OfferSection';

/** Figma: desktop 7218:229, mobile 8662:24721. */
export default function PartnershipSection({
  data,
  className,
}: {
  data: PageTextOnlyCryptoSchema;
  className?: string;
}) {
  return (
    <section
      id="chapter-6"
      data-chapter
      className={cn(
        'relative flex justify-center w-full bg-white px-[2rem] lg:px-0 pt-[8rem] lg:pt-[12.5rem] pb-[8rem] lg:pb-[10rem]',
        className,
      )}
    >
      <div className="flex flex-col w-[min(94.5rem,100%)] overflow-clip rounded-[1rem] border border-[#001B14]/10 bg-white">
        <div className="flex flex-col gap-[2.25rem] w-full max-lg:px-[2rem] max-lg:py-[3rem] lg:p-[5.25rem]">
          {data?.partnershipEyebrow && (
            <p className="mb-0 font-geist font-normal text-[2rem] leading-[1.6] text-[#001B14]/[0.74] lg:w-[56.625rem] whitespace-pre-wrap">
              {data.partnershipEyebrow}
            </p>
          )}

          {data?.partnershipTitle && (
            <div
              className="richtext richtext-start max-lg:w-[min(39rem,100%)] max-lg:[text-wrap:wrap] lg:w-[68.625rem]
              prose-p:font-geist prose-p:font-medium max-lg:prose-p:text-[3.5rem] lg:prose-p:text-[4rem] prose-p:leading-[1.12] prose-p:text-[#001B14] prose-p:mb-0"
            >
              <PortableText
                value={data.partnershipTitle}
                components={richTextComponent}
              />
            </div>
          )}

          <div className="flex flex-col gap-[1.25rem] w-full">
            {data?.partnershipSubhead && (
              <p className="mb-0 font-geist font-medium max-lg:text-[2.75rem] lg:text-[3rem] leading-[1.5] text-[#001B14]">
                {data.partnershipSubhead}
              </p>
            )}
            {data?.partnershipText && (
              <div
                className="richtext richtext-start w-full
                prose-p:font-geist prose-p:font-normal prose-p:text-[2.25rem] prose-p:leading-[1.6] prose-p:text-[#001B14]/[0.74] prose-p:mb-[1.25rem]"
              >
                <PortableText
                  value={data.partnershipText}
                  components={richTextComponent}
                />
              </div>
            )}
          </div>

          <CheckList
            items={data?.partnershipItems}
            panelClassName="bg-[#F4F7F5]"
          />

          {data?.partnershipClosing && (
            <p className="mb-0 font-geist font-medium text-[2.25rem] leading-[1.6] text-[#001B14] whitespace-pre-wrap max-lg:w-[min(43.375rem,100%)] max-lg:[text-wrap:wrap]">
              {data.partnershipClosing}
            </p>
          )}

          {data?.partnershipCTA && (
            <CTAButton
              data={data.partnershipCTA}
              overrideVariant="default"
              className={CARD_BUTTON_CLASS}
            />
          )}
        </div>
      </div>
    </section>
  );
}
